// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"a38e9e95","541":"1913b8a0","703":"7009ac66","787":"b0c2b324"}[chunkId] + ".chunk.js";
};